export default function getOrderAutoShipCodeFromOrder(order): string {
    if (!order.shipping.data.isAutoShip) {
        return null;
    }
    return order.shipping.data.autoShipIsMonthly ? 'M' : 'Q'
}
